import * as React from "react";
import { VacuumElementType } from "../filter-logic/min-max-values";
import { AirMeltElementType } from "../air-melt/filter-logic/min-max-values";
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

require('./styles.scss');

export interface ElementColumnInfo {
  title: string;
  element: VacuumElementType | AirMeltElementType;
  minimum: number;
  maximum: number;
  step: number;
}

interface CompositionFilterUIProps {
  sliderInfo: ElementColumnInfo;
  updateComponentState: (event: any, value: any, boundary: string) => void;
  resetComponentState: () => void;
  elementMinState: number;
  elementMaxState: number;
  sliderActive: boolean;
}

export class CompositionFilterUI extends React.PureComponent<
  CompositionFilterUIProps,
  {}
> {
  render() {
    let col = this.props.sliderInfo;

    const menuOptions = [];
    for (let i = col.minimum; i <= col.maximum; i = i + col.step) {
        menuOptions.push(<MenuItem key={i} value={i}>{i}</MenuItem>);
    }

    return (
      <div className="single-elem-composition">
        <div className="elem-title">{col.title}</div>
        <div className="composition-dropdown">
          <FormControl fullWidth>
            <InputLabel id="select-composition-min">Min</InputLabel>
            <Select
              labelId="select-composition-min" id="select-composition-min"
              value={this.props.elementMinState} label="Min"
              onChange={(event, value) => this.props.updateComponentState(event, value, "min")}
            >
              {menuOptions}
            </Select>
          </FormControl>
         
          <FormControl fullWidth>
            <InputLabel id="select-composition-max">Max</InputLabel>
            <Select labelId="select-composition-max" id="select-composition-max" 
              value={this.props.elementMaxState} label="Max"
              onChange={(event, value) => this.props.updateComponentState(event, value, "max")}
            >
              {menuOptions} 
            </Select>
          </FormControl>
        </div>
        <div className="composition-filter-reset" onClick={this.props.resetComponentState}>
          <SettingsBackupRestoreIcon />&nbsp;Reset
        </div>
      </div>
    );
  }
}
